<div class="layout-wrapper">
    <top-navbar></top-navbar>
    <div class="layout-sidebar">
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <div class="col-sm-12">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>